import { createReducer } from "redux-create-reducer";
import { CLEAR_OFFER_IDS, GET_OFFER_IDS } from "../types/getOfferIdsTypes";

const initialState = {
  data: [],
  isLoading: false,
};

const getOfferIdsReducer = createReducer(initialState, {
  [GET_OFFER_IDS.DEFAULT]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [GET_OFFER_IDS.PENDING]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [GET_OFFER_IDS.REJECTED]: (state, { payload }) => ({
    ...state,
    isLoading: false,
  }),
  [GET_OFFER_IDS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [CLEAR_OFFER_IDS]: (state) => ({
    ...state,
    data: [],
  }),
});

export default getOfferIdsReducer;



// WEBPACK FOOTER //
// ./src/features/score-card/reducers/getOfferIdsReducer.js